import { ElementRef, Injectable, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription, Subject, fromEvent, timer } from "rxjs";
import { filter, take, throttleTime } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class MonitorService {
  constructor(private router: Router) { }

  private subscriptions: Subscription[] = [];
  private gatilhoDisparadoSubject = new Subject<any>();
  gatilhoDisparado$ = this.gatilhoDisparadoSubject.asObservable();
  @ViewChild('routerContainer') routerContainer: ElementRef;

  //Ativa monitor de alertas

  activate(gatilhos: any[]) {
    this.desactivate(); // limpa listeners anteriores

    gatilhos.forEach(gatilho => {
      switch (gatilho.id) {
        case TriggerEnum.Carregamento:
          this.monitorCarregamento(gatilho);
          break;
        case TriggerEnum.Scroll:
          this.monitorScroll(gatilho);
          break;
        case TriggerEnum.Mudança:
          this.monitorBeforeUnload(gatilho);
          break;
        case TriggerEnum.Tempo:
          this.monitorTempo(gatilho);
          break;
      }
    });
  }


  //Desativa monitor de alertas
  desactivate() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
  }


  //Gatilho para carregamento de página
  private monitorCarregamento(gatilho: any) {
    if (this.router.url && this.router.url !== '/') {
      setTimeout(() => {
        this.gatilhoDisparadoSubject.next(gatilho);
      }, 100);
      return;
    }
  }


  //Gatilho para scroll

  private monitorScroll(gatilho: any) {
    const scrollElement = document.querySelector('.col.principal') as HTMLElement;

    const sub = fromEvent(scrollElement, 'scroll')
      .pipe(
        throttleTime(200),
        take(1)
      )
      .subscribe(() => {
        this.gatilhoDisparadoSubject.next(gatilho);
        this.desactivate();
      });

    this.subscriptions.push(sub);
  }


  //Gatilho para saída de página

  private monitorBeforeUnload(gatilho: any) {
    const sub = fromEvent(window, 'pagehide')
      .pipe(take(1))
      .subscribe(() => {
        this.gatilhoDisparadoSubject.next(gatilho);
        this.desactivate();
      });

    this.subscriptions.push(sub);
  }


  //Gatilho para troca de aba pelo usuário
  private monitorVisibilityChange(gatilho: any) {
    const sub = fromEvent(document, 'visibilitychange').pipe(take(1)).subscribe(() => {
      if (document.hidden) {
        this.gatilhoDisparadoSubject.next(gatilho);
      }
    });
    this.subscriptions.push(sub);
  }


  private monitorTempo(gatilho: any) {
    const tempoMs = gatilho.value ? parseInt(gatilho.value) * 1000 : 5000;
    const sub = timer(tempoMs)
      .pipe(take(1))
      .subscribe(() => {
        this.gatilhoDisparadoSubject.next(gatilho);
        this.desactivate();
      });

    this.subscriptions.push(sub);
  }


  private getScrollPercent(): number {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    return (scrollTop / docHeight) * 100;
  }

  private checkCondition(value: number, condicao?: string): boolean {
    if (!condicao) return true;
    if (condicao.includes('>=') && value >= parseFloat(condicao.replace('>=', ''))) return true;
    return false;
  }
}

export enum TriggerEnum {
  Carregamento = 1,
  Mudança = 2,
  Scroll = 3,
  Tempo = 4
}